module.exports = __webpack_public_path__ + "static/gcpbanner-ca465fa04cf03efce3a2442857bc129e.jpg";